// extracted by mini-css-extract-plugin
module.exports = {"section":"SectionTitle_section__2RUm0","title":"SectionTitle_title__34GfP","desc":"SectionTitle_desc__QaYNN"};